module.exports = __webpack_public_path__ + "img/KBP.87615880.png";